import React, { useReducer, useContext } from "react";
import PropTypes from "prop-types";

export const Context = React.createContext();
export const MAX_ATTACHMENT_SIZE = 15000000;
const initialState = {
  attachmentsSize: 0
};

export const ACTIONS_TYPES = {
  ADD_ATTACHMENT: "ADD_ATTACHMENT",
  REMOVE_ATTACHMENT: "REMOVE_ATTACHMENT",
  SET_ATTACHMENT: "SET_ATTACHMENT"
};

function reducer(state, { type, payload }) {
  switch (type) {
    case ACTIONS_TYPES.ADD_ATTACHMENT:
      return {
        ...state,
        attachmentsSize: state.attachmentsSize + payload
      };
    case ACTIONS_TYPES.REMOVE_ATTACHMENT:
      return {
        ...state,
        attachmentsSize: state.attachmentsSize - payload
      };
    case ACTIONS_TYPES.SET_ATTACHMENT:
      return {
        ...state,
        attachmentsSize: payload
      };

    default:
      throw new Error();
  }
}

const FileSizeProvider = React.memo(({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <Context.Provider
      value={{
        state,
        dispatch
      }}
    >
      {children}
    </Context.Provider>
  );
});

FileSizeProvider.propTypes = {
  children: PropTypes.node
};
FileSizeProvider.displayName = "FileSizeProvider";
export const useFileSize = () => {
  const { state, dispatch } = useContext(Context);
  return [state, dispatch];
};

export default FileSizeProvider;
